module.exports = __webpack_public_path__ + "static/media/heart41.71fbbf5e.svg";